import { render, staticRenderFns } from "./ScreenAlertPreview.vue?vue&type=template&id=6cfa8a34&scoped=true"
import script from "./ScreenAlertPreview.vue?vue&type=script&lang=js"
export * from "./ScreenAlertPreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenAlertPreview.vue?vue&type=style&index=0&id=6cfa8a34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa8a34",
  null
  
)

export default component.exports